import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Users, RefreshCw, Clock, ArrowRight } from 'lucide-react';
import './AgentBasedO1.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function AgentBasedO1() {
  const indicators = [
    { icon: <Briefcase size={20} />, text: 'Work is advisory or project-based' },
    { icon: <Users size={20} />, text: 'Engagements involve more than one organization' },
    { icon: <RefreshCw size={20} />, text: 'No single employer represents the full scope of work' },
    { icon: <Clock size={20} />, text: 'Professional activity changes over time' },
  ];

  return (
    <section id="agent-based" className="agent-section">
      <div className="section-container">
        <motion.div
          className="agent-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="agent-title">How O-1 Work Is Structured</h2>

          <p className="agent-body">
            The O-1 visa is a U.S. nonimmigrant classification for individuals of extraordinary
            ability. Unlike traditional employment-based visas, it is tied to the nature of the work
            being performed, not to a single employer. When professional work spans multiple
            engagements or does not fit a single-employer model, an agent-based structure exists to
            support and coordinate that work within an approved scope.
          </p>

          <div className="agent-indicators">
            <h3 className="indicators-label">Common Indicators</h3>
            <div className="indicators-grid">
              {indicators.map((indicator, index) => (
                <motion.div
                  key={index}
                  className="indicator-item"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <div className="indicator-icon">{indicator.icon}</div>
                  <span className="indicator-text">{indicator.text}</span>
                </motion.div>
              ))}
            </div>
          </div>

          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="agent-cta">
            Explore whether an agent-based O-1 is right for you
            <ArrowRight size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default AgentBasedO1;
